<template>
    <div class="documentIndex">
        <div class="content" style="margin-top: 20px;">
            <div class="platform">
                <div>平台当前上传识别人数共 {{ userObj.userNum }} 位，</div>
                <div>平台待处理图片 {{ userObj.pictureNum }} 张</div>
            </div>
            <defUploadFile @getUploadList="getUploadList"></defUploadFile>
            <div class="handles">
                <div class="startButton">
                    <el-button type="primary" @click="docMethods(1, '单证分类')">单证分类</el-button>
                    <el-button type="primary" @click="docMethods(2, '自动识别')">自动识别</el-button>
                    <el-button type="primary" @click="docMethods(3,' 指定识别')" class="mar-r-10">指定识别</el-button>
                    <deleteAll :deleteSelection="deleteSelection" @on-deleteAll="deleteFinish"></deleteAll>
                </div>
                <div class="right">
                    <searchFile @on-search="onSearch" @on-clear="onClear"></searchFile>
                    <el-date-picker v-model="dateValue" type="daterange" range-separator="～" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
                        @change="dateChange">
                    </el-date-picker>
                </div>
            </div>
            <!-- 表格组件 https://xuliangzhan_admin.gitee.io/vxe-table/#/table/api -->
            <!-- 进度条 https://github.com/usablica/progress.js/wiki/API -->
            <!-- show-overflow -->
            <vxe-table highlight-hover-row row-id="seqNo" :row-key="false" ref="xTree" :tree-config="{
                lazy: true,children: 'children',hasChild: 'hasChildren',line: true,
                expandRowKeys: defaultExpandRowKeys,loadMethod: lazyLoadTable}" :row-class-name="tableRowClassName"
                :checkbox-config="{labelField: 'resName',checkMethod}"
                :sort-config="{trigger: 'cell', defaultSort: {field: 'uploadTime', order: 'desc'}}" :data="tableData"
                class="docs_table" width="100%" @toggle-tree-expand="toggleTreeExpand"
                @checkbox-change="selectChangeEvent" @checkbox-all="checkboxAll">
                <vxe-table-column type="checkbox" title="ElInput" width="400" tree-node :edit-render="{name: 'ElInput'}"
                    show-overflow="ellipsis" fixed="left">
                    <template v-slot:header="{ column }">
                        <span>文件序号</span>
                        <span class="single-title">文件名</span>
                    </template>
                    <template v-slot="{row}">
                        <el-tooltip class="item" effect="dark"
                            :content="row.resName.substr(0,row.resName.lastIndexOf('.'))+'.'+row.format.toLocaleLowerCase()"
                            placement="top">
                            <span>
                                <span class="file-id" :class="{grey: row.tempFile}">{{row.tempFile ? '' :
                                    row.seqNo}}</span>
                                <span class="file-name" :class="{grey: row.tempFile}">{{
                                    row.resName.substr(0,row.resName.lastIndexOf('.'))}}</span>
                                <span class="file-format"
                                    :class="{grey: row.tempFile}">.{{row.format.toLocaleLowerCase()}}</span>
                                <em class="file-size">{{row.sizeWithUnit.toUpperCase()}}</em>
                            </span>
                        </el-tooltip>
                    </template>
                </vxe-table-column>
                <!-- <vxe-table-column field="seqNo" title="文件序号">
                    <template v-slot="{row}">
                        <span :title="row.seqNo" class="file-id" :class="{grey: row.tempFile}">{{row.tempFile ? '' : row.seqNo}}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="resName" title="文件名" width="60"  show-overflow="title">
                    <template v-slot="{row}">
                        <span :title="row.resName" class="file-name" :class="{grey: row.tempFile}">{{row.resName.split('.')[0]}}</span>
                        <span class="file-format" :class="{grey: row.tempFile}">.{{row.format}}</span>
                        <em class="file-size">{{row.sizeWithUnit.toUpperCase()}}</em>
                    </template>
                </vxe-table-column> -->
                <vxe-table-column field="category" title="单证类型" show-overflow="tooltip">
                    <template v-slot="{row}">
                        <template>
                            <span v-if="row.level !== 1">{{row.category}}</span>
                        </template>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="" title="进度" show-overflow="tooltip">
                    <template v-slot="{row}">
                        <tableSocketProcess :row="row"></tableSocketProcess>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="" title="识别结果">
                    <template v-slot="{row}">
                        <tableSocketResult :row="row"></tableSocketResult>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="customerName" title="归属客户" show-overflow="tooltip">
                    <template v-slot="{row}">
                        <template>
                            <span>{{row.customerName}}</span>
                        </template>
                    </template>
                </vxe-table-column>

                <vxe-table-column field="customerCode" title="客户代码" show-overflow="tooltip">
                    <template v-slot="{row}">
                        <template>
                            <span>{{row.customerCode}}</span>
                        </template>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="uploadTime" title="上传时间" sortable>
                    <template v-slot="{row}" style="display: block;">
                        <div class="file-time">{{row.uploadTime && row.uploadTime.split(' ')[0]}}</div>
                        <div class="file-time">{{row.uploadTime && row.uploadTime.split(' ')[1].substr(0,5)}}</div>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="" title="操作" width="130" fixed="right">
                    <template v-slot="{row}">
                        <!-- 查看结果+删除 -->
                        <span style="color:#16336C;font-size:14px;cursor: pointer;" @click="resultInfo(row)">查看结果</span>
                        <div class="shugang"></div>
                        <tableDataDelete :row="row" @on-delete="deleteFinish"></tableDataDelete>
                    </template>
                </vxe-table-column>
            </vxe-table>
            <el-pagination layout="total, prev, pager, next, jumper" :page-size="10" :total="total"
                :current-page.sync="currentPage" @current-change="pageCurrentChange"></el-pagination>
        </div>
        <el-dialog class="def-dialog" :title="defVisibleTitle" :visible.sync="defVisible" width="30%" @close="defClose"
            :close-on-click-modal="false" :append-to-body="true" ref="defDialog">
            <el-card shadow="never" class="border-none cargo-form">
                <el-form :model="visibleForm" size="mini" :rules="rules" ref="ruleForm"
                    :label-width="defFlag == 2 ? '0' : '90px'">
                    <el-form-item label="模板ID号" v-if="defFlag === 3" prop="templateId">
                        <el-input type="number" clearable v-model="visibleForm.templateId" @change="blurChange($event)"
                            placeholder="请输入模板ID进行查找"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="OCR" v-if="defFlag === 2 || defFlag === 3" prop="templateType">
            <el-select v-model="templateType" clearable placeholder="请选择">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
                    <el-form-item label="" style="margin:0;padding:0" v-if="defFlag === 2">
                        <div style="display: flex">
                            <i class="icon-inotice auto"></i>
                            <h3 style="font-size: 16px;color: #224AA0">确认自动识别？</h3>
                        </div>
                    </el-form-item>
                    <el-form-item label="单证类型" v-if="defFlag === 1 || defFlag === 3" prop="category">
                        <el-select v-model="visibleForm.category" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角度" v-if="defFlag === 3" prop="angle">
                        <el-input type="number" v-model="visibleForm.angle" maxlength="2">
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-card>
            <div class="dialog-footer">
                <el-button @click="defVisible = false" size="mini">取消</el-button>
                <el-button type="primary" @click="cfmDefVisible" size="mini">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    import _ from 'lodash'

    import searchFile from '../common/searchFile'
    import defUploadFile from './defUploadFile'
    import deleteAll from './deleteAll'
    import tableSocketProcess from './defTableSocketProcess'
    import tableSocketResult from './defTableSocketResult'
    import tableDataDelete from './tableDataDelete'

    export default {
        name: 'DocesIndex',
        props: {},
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now()
                    }
                },
                englishDoc: false,
                tableData: [],
                total: 0,
                currentPage: 1,
                subNodeList: [],
                threeNodeList: [],
                defaultExpandRowKeys: [],
                dialogVisible: false,
                noteVisible: false,
                dateValue: null,
                currentRow: 0,
                websoketIds: [],
                selection: [],
                searchText: '',
                deleteSelection: [],
                userObj: {
                    userNum: 0,
                    pictureNum: 0
                },
                failTimes: 0,
                defVisible: false,
                visibleForm: {},
                ocr: '',
                options: [],
                temPptions: [],
                typeOptions: [
                    {
                        value: 1,
                        label: '英文OCR'
                    },
                    {
                        value: 2,
                        label: '中英文OCR'
                    }
                ],
                templateType: '',
                defVisibleTitle: '',
                defFlag: '',
                newSelection: [],
                rules: {
                    category: [
                        {
                            required: true,
                            message: '请选择单证类型',
                            trigger: 'change'
                        }
                    ],
                    templateId: [
                        {
                            required: true,
                            message: '请输入模板ID',
                            trigger: 'change'
                        }
                    ]
                },
                selectionArr: []
            }
        },
        computed: {
            ...mapGetters(['localPage'])
        },
        watch: {
            $route(to, from) {
                if (to.path.includes('endoc')) {
                    this.englishDoc = true
                    this.getUploadList()
                } else {
                    this.englishDoc = false
                    this.getUploadList()
                }
                if (from.name === 'artificial' || from.name === 'editpage') {
                    this.getUploadList()
                }
            }
        },
        created() { },
        mounted() {
            // this.$message({
            //     message: '恭喜你，这是一条成功消息',
            //     type: 'info',
            //     duration: 30000000
            // });

            this.passportVerify()
        },
        destroyed() {
            //注销后清除缓存
            // this.removeLocal();
        },
        methods: {
            //自定义识别查看结果，现在参数是带有识别成功和失败标识的。后期需要去掉。
            resultInfo(item) {
                let obj = JSON.stringify({
                    id: item.id,
                    name: item.resName,
                    flag: true,
                    search: 'success',
                    hasChildren: item.hasChildren,
                    pId: item.id,
                    type: this.$route.name.split('-')[0]
                })
                this.$router.push({
                    path: 'successPageRecog',
                    query: {
                        id: item.id,
                        name: item.resName,
                        flag: true,
                        search: 'success',
                        hasChildren: item.hasChildren,
                        pId: item.id,
                        type: this.$route.name.split('-')[0],
                        params: obj
                    }
                })

                return false
            },
            async passportVerify() {
                // 从官网登陆过来增加token,存入header
                let token = this.$route.query.token
                if (token) {
                    localStorage.setItem(
                        'BAILIAN-SHIBIE-OFFICEWEBSITE-TOKEN',
                        token
                    )

                    let url = this.$resource.getCurrentUser
                    let res = await this.$axios({
                        url: url,
                        method: 'get'
                    })

                    localStorage.setItem(
                        'BAILIAN-SHIBIE-USERNAME',
                        res.data.data.nickName
                    )
                    this.$store.dispatch('setUserName', res.data.data.nickName)
                }

                if (this.$route.path.includes('endoc') === true) {
                    this.englishDoc = true
                } else {
                    this.englishDoc = false
                }

                this.getTaskStatus()

                this.$store.dispatch('setFullExpand', 'icon-expandout')

                this.getUploadList(this.localPage)
            },
            getTaskStatus() {
                // 查询平台当前上传识别人数
                let url = this.$wsUrl + this.$resource.taskStatus

                const ws = new WebSocket(url)

                // 连接后监听
                ws.onopen = () => {
                    //console.log('websocket,taskStatus已打开', ws.readyState)
                    // ws.send('Ping');
                }

                //获得消息事件
                ws.onmessage = msg => {
                    if (msg.data === '连接成功') {
                        // ws.send('连接成功' + id);
                    }

                    if (msg.data !== '连接成功') {
                        let obj = JSON.parse(msg.data)
                        this.userObj = obj
                    }
                }
                // 监听连接关闭
                ws.onclose = data => {
                    if (this.failTimes >= 5) {
                        return
                    }

                    // 递归重连websoket
                    setTimeout(() => {
                        this.failTimes++
                        this.getTaskStatus()
                    }, 2000)
                    //console.log('websocket,taskStatus已关闭', data)
                    console.log('websocket,taskStatus已关闭')
                }
                //发生了错误事件
                ws.onerror = () => {
                    if (this.failTimes >= 5) {
                        return
                    }

                    // 递归重连websoket
                    setTimeout(() => {
                        this.failTimes++
                        this.getTaskStatus()
                    }, 2000)
                    //console.log('websocket发生了错误')
                    //此时可以尝试刷新页面
                }
            },
            getUploadList(page = 1, searchText, date = ['', '']) {
                if (date === null) {
                    date = ['', '']
                }
                // console.log(radio, searchText, date)
                let url = this.$resource.listUploadList
                    .replace('{pageNum}', page)
                    .replace('{pageSize}', 10)
                    .replace('{parentId}', 0)
                this.$axios({
                    url: url,
                    // url: 'http://localhost:8080/index.json',
                    method: 'post',
                    params: {},
                    timeout: 1000 * 60,
                    transformResponse: [
                        function (data) {
                            // 对 data 进行任意转换处理
                            let result = JSON.parse(data)
                            if (result.code === '401') {
                                return
                            }
                            result.data.list &&
                                result.data.list.forEach(item => {
                                    if (item.category == 0) {
                                        item.category = ''
                                    }

                                    //新增属性
                                    item.random = 0
                                })
                            return result
                        }
                    ],
                    data: {
                        content: searchText,
                        beginTime: date[0],
                        endTime: date[1],
                        type: 3
                    }
                })
                    .then(res => {
                        this.$refs.xTree.clearTreeExpand()

                        this.total = res.data.data.total
                        this.tableData = res.data.data.list
                        this.currentPage = this.localPage

                        //刷新页面，保证连接ws
                        this.tableData.forEach(item => {
                            let status =
                                item.status === 0
                                    ? item.status
                                    : item.status.split('_')[1]
                            if (
                                status === '等待转换' ||
                                status === '正在转换' ||
                                status === '正在分类' ||
                                status === '等待分类' ||
                                status === '正在识别' ||
                                status === 0
                            ) {
                                //未识别成功，不允许展开子集
                                item.hasChildren = false

                                // 保持进度中继续
                                let name = 'BAILIAN-SHIBIEUPLOAD-' + item.id
                                this.getItem(name, item)

                                this.getWebsocket(item.id, 'refresh')
                            }
                        })

                        // this.tableData.unshift({
                        //     tempFile: true,
                        //     category: '-',
                        //     format: 'pdf',
                        //     seqNo: Math.floor(Math.random() * 300),
                        //     id: Math.floor(Math.random() * 300),
                        //     recognitionCount: {},
                        //     level: 1,
                        //     resName: 'eeee.pdf',
                        //     size: 333333 / 1024,
                        //     sizeWithUnit: (33333333 / 1024).toFixed(2) + 'K',
                        //     status: "正在上传中",
                        //     uploadTime: '2020-02-29 12:01:50',
                        //     uploadUser: "",
                        //     predictCost: 9,
                        //     count: 0,
                        //     uploadTrip: 0,
                        //     uploadCo: 0,

                        // })
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            pageCurrentChange(x) {
                this.$store.dispatch('setLocalPage', x)
                this.currentPage = x

                this.getUploadList(x, this.searchText, this.dateValue)
            },
            checkMethod({ row }) {
                return row
            },
            removeLocal() {
                Object.keys(localStorage).forEach(item => {
                    item.indexOf('BAILIAN-SHIBIEUPLOAD-') != -1
                        ? localStorage.removeItem(item)
                        : ''
                })
            },
            getItem(name, row) {
                let count = this.$utils.storage(name)
                if (count) {
                    progressJs('#uploadProgress_' + row.id)
                        .setOptions({ overlayMode: false })
                        .set(count)
                }
            },
            toggleTreeExpand({ expanded, row, rowIndex }, event) {
                //上传的开始阶段，点击没反应执行重新加载，row,children获取不到
                if (row.children && row.children.length === 0) {
                    this.$refs.xTree.reloadTreeChilds(row)
                }
                // if (this.subNodeList.length > 0) {
                //     this.subNodeList.forEach(item => {
                //         this.websoketIds.push(item.id);
                //     })

                //     this.websoketIds = _.uniq(this.websoketIds);
                //     this.websoketIds.forEach(item => {
                //         this.getWebsocket(item);
                //     })
                // }
            },
            lazyLoadTable({ row }) {
                // 未识别完成，文件不能展开
                if (row.hasChildren === false) {
                    return
                }
                let url = this.$resource.listUploadList
                    .replace('{pageNum}', 1)
                    .replace('{pageSize}', 600)
                    .replace('{parentId}', row.id)

                if (row.format === 'zip' || row.format === 'rar') {
                    return this.$axios({
                        url: url,
                        method: 'post',
                        params: {},
                        transformResponse: [
                            function (data) {
                                // 对 data 进行任意转换处理
                                let result = JSON.parse(data)
                                result.data.list &&
                                    result.data.list.forEach(item => {
                                        if (item.category === 0) {
                                            item.category = ''
                                        }
                                        //新增属性
                                        item.random = 0
                                    })
                                return result
                            }
                        ]
                    })
                        .then(res => {
                            //二级
                            if (res && res.data && res.data.data) {
                                let list = res.data.data.list
                                this.subNodeList = list

                                let x = this.tableData.findIndex(item => {
                                    return item.id === row.id
                                })
                                this.tableData[x].children = list

                                if (list.length > 0) {
                                    list.forEach(item => {
                                        if (item.status.indexOf('识别成功') < 0) {
                                            this.websoketIds.push(item.id)
                                        }
                                    })

                                    let uniqx = _.uniq(this.websoketIds)
                                    uniqx.forEach(item => {
                                        this.getWebsocket(item)
                                    })
                                }
                                return list
                            } else {
                                return []
                            }
                        })
                        .catch(e => {
                            console.log(e)
                        })
                } else {
                    return this.$axios({
                        url: url,
                        method: 'post',
                        params: {},
                        transformResponse: [
                            function (data) {
                                // 对 data 进行任意转换处理
                                let result = JSON.parse(data)
                                result.data.list &&
                                    result.data.list.forEach(item => {
                                        if (item.category === 0) {
                                            item.category = ''
                                        }
                                        //新增属性
                                        item.random = 0
                                    })
                                return result
                            }
                        ]
                    })
                        .then(res => {
                            //三级
                            if (res.data.data) {
                                let list = res.data.data.list
                                this.threeNodeList = list

                                if (row.level === 1) {
                                    let x = this.tableData.findIndex(item => {
                                        return item.id === row.id
                                    })
                                    // console.log(row, list, 0)
                                    this.tableData[x].children = list

                                    if (list.length > 0) {
                                        list.forEach(item => {
                                            if (
                                                item.status.indexOf('识别成功') < 0
                                            ) {
                                                this.getWebsocket(item.id)
                                            }
                                        })
                                    }
                                }

                                return list
                            } else {
                                return []
                            }
                        })
                        .catch(e => {
                            console.log(e)
                        })
                }
            },
            getWebsocket(id, type) {
                if (!id) {
                    return
                }

                if (typeof WebSocket == 'undefined') {
                    //console.log('您的浏览器不支持WebSocket')
                } else {
                    //console.log('您的浏览器支持WebSocket')
                    //实现化WebSocket对象，指定要连接的服务器地址与端口  建立连接

                    let url =
                        this.$wsUrl +
                        this.$resource.websocket.replace('{resId}', id)

                    const ws = new WebSocket(url)
                    // 连接后监听
                    ws.onopen = () => {
                        //console.log('websocket,upload已打开', ws.readyState)
                        //ws.send("这是来自客户端的消息" + location.href + new Date());
                    }
                    //获得消息事件
                    let count = 0
                    ws.onmessage = msg => {
                        //console.log(msg.data, 'msg.data')
                        if (msg.data === '连接成功') {
                            // ws.send('连接成功' + id);
                        }

                        if (msg.data !== '连接成功') {
                            let data = JSON.parse(msg.data)
                            if (type) {
                                count++
                                //刷新页面后，只执行一次主动发送
                                //console.log(data.status, 'data.status')
                                if (
                                    count === 1 &&
                                    data.status.split('_')[1] !== '识别成功' &&
                                    data.status.split('_')[1] !== '识别完成'
                                ) {
                                    // 发送给后端
                                    ws.send(
                                        JSON.stringify({
                                            resId: id,
                                            refresh: true
                                        })
                                    )
                                }
                            }

                            //父结点
                            this.tableData.forEach((item, index) => {
                                if (item.id === data.resId) {
                                    item.status = data.status
                                    if (
                                        item.status.split('_')[1] === '分类完成' &&
                                        data.recognitionCount &&
                                        data.recognitionCount.failed !=
                                        data.recognitionCount.total
                                    ) {
                                        item.recognitionCount = undefined
                                    } else {
                                        item.recognitionCount =
                                            data.recognitionCount
                                    }
                                    item.category = data.category
                                    item.certiNo = data.certiNo
                                    item.brand = data.brand
                                    item.resId = data.resId
                                    item.predictCost = data.predictCost
                                    item.remark =
                                        data.recognitionCount &&
                                        data.recognitionCount.remark
                                    // pdf文件结束是识别成功，zip是识别完成
                                    if (
                                        item.recognitionCount &&
                                        (item.status.split('_')[1] === '识别成功' ||
                                            item.status.split('_')[1] ===
                                            '识别完成' ||
                                            item.status.split('_')[1] ===
                                            '识别失败')
                                    ) {
                                        if (
                                            item.format === 'jpg' ||
                                            item.format === 'jpeg' ||
                                            item.format === 'png' ||
                                            item.format === 'doc' ||
                                            item.format === 'docx'
                                        ) {
                                            item.hasChildren = false
                                        } else {
                                            // 识别成功允许展开表下拉
                                            item.hasChildren = true
                                        }
                                    } else {
                                        item.hasChildren = false
                                    }
                                    if (item.status.split('_')[1] === '转换完成') {
                                        item.hasChildren = true
                                    }
                                } else {
                                    //展开的子结点
                                    if (item.children && item.children.length > 0) {
                                        item.children.forEach(child => {
                                            if (child.id === data.resId) {
                                                child.status = data.status
                                                child.predictCost = data.predictCost
                                                child.recognitionCount =
                                                    data.recognitionCount
                                                child.remark =
                                                    data.recognitionCount &&
                                                    data.recognitionCount.remark
                                                child.category = data.category
                                                child.certiNo = data.certiNo
                                                child.brand = data.brand
                                                child.resId = data.resId
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }
                    // 监听连接关闭
                    ws.onclose = data => {
                        //console.log('websocket,upload已关闭', data)
                    }
                    //发生了错误事件
                    ws.onerror = () => {
                        //console.log('websocket发生了错误')
                        //此时可以尝试刷新页面
                    }
                    // sendBtn.onclick = () => {
                    //     // 点击发送按钮。将数据发送给服务端
                    //     ws.send(msgBox.value)
                    // }
                    // exit.onclick = () => {
                    //     // 客户端主动关闭连接
                    //     ws.close()
                    // }
                }
            },
            tableRowClassName({ seq, row, rowIndex, $rowIndex }) {
                // 树形表格样式区分
                if (row.tempFile) {
                    return 'child-row--temp'
                }
                if (row.level === 1) {
                    return 'child-row--level-1'
                }
                if (row.level === 2) {
                    if (row.first === true && row.last === true) {
                        return 'child-row--level-2 first-row first-row-one'
                    }
                    if (row.first === true && row.last === false) {
                        return 'child-row--level-2 first-row'
                    }
                    if (row.last === true) {
                        return 'child-row--level-2 last-row'
                    }

                    return 'child-row--level-2'
                }
                if (row.level === 3 && row.format === 'pdf') {
                    if (row.first === true && row.last === true) {
                        return 'child-row--level-3-no first-row first-row-one'
                    }
                    if (row.first === true && row.last === false) {
                        return 'child-row--level-3-no first-row'
                    }
                    if (row.last === true) {
                        return 'child-row--level-3-no last-row'
                    }
                    return 'child-row--level-3-no'
                }
                if (row.level === 3) {
                    if (row.first === true && row.last === true) {
                        return 'child-row--level-3 first-row first-row-one'
                    }
                    if (row.first === true && row.last === false) {
                        return 'child-row--level-3 first-row'
                    }
                    if (row.last === true) {
                        return 'child-row--level-3 last-row'
                    }
                    return 'child-row--level-3'
                }
                if (row.level === 4) {
                    if (row.first === true && row.last === true) {
                        return 'child-row--level-4 first-row first-row-one'
                    }
                    if (row.first === true && row.last === false) {
                        return 'child-row--level-4 first-row'
                    }
                    if (row.last === true) {
                        return 'child-row--level-4 last-row'
                    }
                    return 'child-row--level-4'
                }
                return ''
            },
            onSearch(txt) {
                this.searchText = txt
                this.getUploadList(this.currentPage, txt, this.dateValue)
            },
            onClear() {
                this.searchText = ''
                // this.getUploadList(this.currentPage);
            },
            dateChange(dateFormat) {
                let x
                if (dateFormat === null) {
                    x = ['', '']
                } else {
                    x = dateFormat
                }
                this.getUploadList(this.currentPage, this.searchText, x)
            },
            async getSubset(selection, type) {
                //选中父元素，如果父元素有子集，就懒加载子集
                for (let item of selection) {
                    if (
                        (item.hasChildren === true &&
                            item.children === null &&
                            item.level === 1) ||
                        (item.hasChildren === true &&
                            item.children === undefined &&
                            item.level === 1) ||
                        (type &&
                            item.hasChildren === true &&
                            item.children === undefined)
                    ) {
                        let url = this.$resource.listUploadList
                            .replace('{pageNum}', 1)
                            .replace('{pageSize}', 600)
                            .replace('{parentId}', item.id)
                        try {
                            let res = await this.$axios({
                                url: url,
                                method: 'post',
                                params: {},
                                transformResponse: [
                                    function (data) {
                                        // 对 data 进行任意转换处理
                                        let result = JSON.parse(data)
                                        result.data.list &&
                                            result.data.list.forEach(item => {
                                                if (item.category === 0) {
                                                    item.category = ''
                                                }
                                                //新增属性
                                                item.random = 0
                                            })
                                        return result
                                    }
                                ]
                            })

                            //三级
                            if (res.data.data) {
                                let list = res.data.data.list
                                item.children = list

                                // 处理压缩包的选中
                                if (
                                    selection[0].format === 'zip' ||
                                    selection[0].format === 'rar'
                                ) {
                                    this.getSubset(list, 'zip')
                                }
                            }
                        } catch (e) {
                            // statements
                            console.log(e)
                        }
                    }
                }
                return selection
            },
            async checkboxAll({ selection, reserves, checked }, event) {
                this.selection = await this.getSubset(selection)
                this.deleteSelection = selection
            },
            async selectChangeEvent(
                {
                    selection,
                    reserves,
                    checked,
                    row,
                    rowIndex,
                    $rowIndex,
                    column,
                    columnIndex,
                    $columnIndex,
                    cell
                },
                event
            ) {
                this.selection = await this.getSubset(selection)
                this.deleteSelection = selection
            },
            deleteFinish() {
                this.getUploadList(this.currentPage)
            },
            async docMethods(v, str) {
                let arr = this.flatArray(this.selection)
                //console.log(arr, 'rr11')
                if (arr.length > 0) {
                    for (let item of arr) {
                        if (item.hasChildren && !item.children) {
                            let url = this.$resource.listUploadList
                                .replace('{pageNum}', 1)
                                .replace('{pageSize}', 600)
                                .replace('{parentId}', item.id)
                            try {
                                let res = await this.$axios({
                                    url: url,
                                    method: 'post',
                                    params: {}
                                })
                                //三级
                                if (res.data.data) {
                                    let list = res.data.data.list
                                    item.children = list
                                }
                            } catch (e) {
                                // statements
                                console.log(e)
                            }
                        }
                    }
                }
                this.selectionArr = this.flatArray(arr)
                //console.log(this.selectionArr, 'arr1111')
                if (this.selection.length > 0) {
                    this.defVisibleTitle = v === 2 ? '' : str
                    this.defFlag = v
                    this.getlistAllCertiType()
                    this.$nextTick(() => {
                        this.defVisible = true
                    })
                } else {
                    this.$message.info('请选中需要操作的文件')
                }
            },
            flatArray(arr) {
                return [].concat(
                    ...arr.map(x =>
                        Array.isArray(x.children) ? this.flatArray(x.children) : x
                    )
                )
            },
            doAction(v) {
                let ary = []
                let newData = {}
                let flag = v === 2 ? true : false
                this.$refs.ruleForm.validate(async valid => {
                    if (valid) {
                        this.selectionArr.forEach(e => {
                            if (!e.hasChildren) {
                                if (
                                    Object.keys(newData).indexOf('' + e.pId) === -1
                                ) {
                                    newData[e.pId] = {
                                        recognition: flag,
                                        imageList: []
                                    }
                                    if (v === 3) {
                                        newData[
                                            e.pId
                                        ].templateId = this.visibleForm.templateId
                                    }
                                    if (v === 1 || v === 3) {
                                        newData[
                                            e.pId
                                        ].category = this.visibleForm.category
                                    }
                                }
                                //对应插入属性值
                                newData[e.pId].imageList.push({
                                    angle: v === 3 ? this.visibleForm.angle : 0,
                                    resId: e.id,
                                    resName: e.resName,
                                    resPath: e.resPath
                                })
                            }
                        })
                        let url = this.$resource.picRecognition
                        this.$axios({
                            url: url,
                            method: 'post',
                            data: Object.values(newData)
                        })
                            .then(res => {
                                this.$message.success('操作成功')
                                this.getUploadList()
                                this.$refs.xTree.clearCheckboxRow()
                                this.defClose()
                            })
                            .catch(e => {
                                console.log(e)
                            })
                    }
                })
            },
            cfmDefVisible() {
                this.doAction(this.defFlag)
            },
            defClose() {
                this.defVisible = false
            },
            getlistAllCertiType() {
                let url = this.$resource.listCategory
                this.$axios({
                    url: url,
                    method: 'get'
                })
                    .then(res => {
                        this.options = res && res.data.data
                    })
                    .catch(e => {
                        console.log(e)
                    })
            },
            blurChange(x) {
                let url = this.$resource.getTemplateInfo.replace('{id}', x)
                this.$axios({
                    url: url,
                    method: 'get'
                })
                    .then(res => {
                        this.$nextTick(() => {
                            //console.log(res, 'res')
                            this.$set(
                                this.visibleForm,
                                'category',
                                res.data.data ? res.data.data.category : ''
                            )
                        })
                    })
                    .catch(e => {
                        console.log(e)
                    })
            }
        },
        components: {
            searchFile,
            deleteAll,
            defUploadFile,
            tableSocketProcess,
            tableSocketResult,
            tableDataDelete
        }
    }
</script>
<style>
    @import "./documentIndex.css";

    .mar-r-10 {
        margin-right: 10px;
    }

    .def-dialog {
        .el-dialog__body {
            padding: 0;
        }

        .dialog-footer {
            padding: 10px;
            text-align: right;
        }

        .el-select {
            width: 100%;
        }
    }

    .icon-inotice.auto {
        font-size: 18px;
        position: relative;
        top: 4px;
        margin-right: 10px;
    }

    .shugang {
        /*position:relative;*/
        /*top: 30px;*/
        width: 1px;
        height: 8px;
        background: #d8d8d8;
        border-radius: 1px;
        /*display: inline-block;*/
        margin: 0 10px;
    }
</style>